function normalizeStaggerTargets(targets) {
	if (!Array.isArray(targets) || targets.length === 0) {
		return targets
	}

	var groupIndexByKey = new Map()
	var nextIndex = 0
	for (var i = 0; i < targets.length; i++) {
		var key = targets[i]._layNavStaggerGroupKey
		if (key) {
			if (!groupIndexByKey.has(key)) {
				groupIndexByKey.set(key, nextIndex)
				nextIndex++
			}
			targets[i]._layNavStaggerIndex = groupIndexByKey.get(key)
		} else {
			targets[i]._layNavStaggerIndex = nextIndex
			nextIndex++
		}
	}

	var logicalLength = Math.max(1, nextIndex)
	for (var j = 0; j < targets.length; j++) {
		targets[j]._layNavStaggerLength = logicalLength
	}

	return targets
}

function getNormalizedStaggerIndex(el, fallbackIndex) {
	return el && typeof el._layNavStaggerIndex === 'number'
		? el._layNavStaggerIndex
		: fallbackIndex
}

function getNormalizedStaggerLength(el, fallbackLength) {
	return el && typeof el._layNavStaggerLength === 'number'
		? el._layNavStaggerLength
		: fallbackLength
}

function clearNormalizedStaggerTargets(targets) {
	if (!Array.isArray(targets)) {
		return
	}
	for (var i = 0; i < targets.length; i++) {
		delete targets[i]._layNavStaggerIndex
		delete targets[i]._layNavStaggerLength
		delete targets[i]._layNavStaggerGroupKey
	}
}

export { normalizeStaggerTargets, getNormalizedStaggerIndex, getNormalizedStaggerLength, clearNormalizedStaggerTargets }
